import { Check } from '@mui/icons-material';
import { Chip, Stepper, Step, StepLabel, Typography } from '@mui/material';
import { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { RandomSetting } from 'types/container';

interface RandomSettingsBoxProps {
    randomSettings: RandomSetting[];
}

function RandomSettingsBox({ randomSettings }: RandomSettingsBoxProps) {
    return (
        <>
            <Chip
                sx={{
                    backgroundColor: '#F7F4FB',
                    boxShadow: `0px 4px 4px 0px rgba(0, 0, 0, 0.25)`,
                    height: 'fit-content'
                }}
                label={
                    <Stepper activeStep={-1} nonLinear sx={{ flexWrap: 'wrap' }} connector={null}>
                        {randomSettings.map((item, index) => (
                            <Step key={`item-${index}`} completed>
                                <StepLabelComponent item={item} />
                            </Step>
                        ))}
                    </Stepper>
                }
            />
        </>
    );
}

interface StepLabelComponentProps {
    item: RandomSetting;
}

export const StepLabelComponent = ({ item }: StepLabelComponentProps) => {
    const displayNameLength = item?.display_name?.length;
    const isLongDisplayName = displayNameLength && displayNameLength > 63;
    const width = isLongDisplayName ? '40rem' : 'auto';

    return (
        <StepLabel icon={<Check color="primary" />}>
            {item.name === 'amountQuestions' && <FormattedMessage id="amount" values={{ amount: item.value }} />}
            {item.name === 'difficultyLevelFrom' && <FormattedMessage id="level-from" values={{ level: item.value }} />}
            {item.name === 'difficultyLevelTo' && <FormattedMessage id="level-to" values={{ level: item.value }} />}
            {item.name === 'questionType' && (
                <Typography noWrap width={width}>
                    {item.display_name &&
                        item.display_name.split(',').map((displayName, key) => (
                            <Fragment key={key}>
                                {key ? ', ' : ''}
                                <FormattedMessage id={displayName} />
                            </Fragment>
                        ))}
                </Typography>
            )}
            {item.name === 'collectionType' && (
                <Typography noWrap width={width}>
                    {item.display_name &&
                        item.display_name.split(',').map((displayName, key) => (
                            <Fragment key={key}>
                                {key ? ', ' : ''}
                                <FormattedMessage id={displayName} />
                            </Fragment>
                        ))}
                </Typography>
            )}
            {item.name === 'unitType' && <FormattedMessage id={item.display_name} />}
            {item.name === 'mainTag' && item.display_name}
            {item.name === 'subTag' && item.display_name}
            {item.name === 'startDate' && (
                <FormattedMessage
                    id="start-date-r"
                    values={{
                        date: item.value
                    }}
                />
            )}
            {item.name === 'endDate' && <FormattedMessage id="end-date-r" values={{ date: item.value }} />}
        </StepLabel>
    );
};

export default RandomSettingsBox;
